export default __webpack_public_path__ + "static/hero-background-101eea66b60dee016f5b03a13ded0305.jpg";